import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMultistageShared = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M40 37.3q3.75 0 5.875 1.325T48 42.05V43H32v-.95q0-2.1 2.125-3.425T40 37.3M38.9 6.225q1.149 0 2.011.864.864.863.864 2.01V22H38.9V9.1H9.1v29.8H28v2.875H9.1q-1.148 0-2.011-.864-.864-.863-.864-2.01V9.1q0-1.149.864-2.011.863-.864 2.012-.864z" }), /* @__PURE__ */ _jsx("path", { d: "M40.004 27q1.504 0 2.575 1.075 1.071 1.076 1.071 2.58 0 1.503-1.075 2.573-1.074 1.072-2.579 1.072-1.504 0-2.575-1.075t-1.071-2.579 1.075-2.575Q38.5 27 40.004 27M23.45 33.9H12.575v-2.875H23.45zM29.45 25.425H18.575V22.55H29.45zM35.45 16.95H24.575v-2.875H35.45z" })]
});
export default SvgMultistageShared;
